export class HttpStatusCode {
    static NOT_FOUND = 404;
    static OK = 200;
    static NO_CONTENT = 204;
    static CREATED = 201;
    static BAD_REQUEST = 400;
    static UNAUTHORIZED = 401;
    static FORBIDDEN = 403;    
    static INTERNAL_SERVER_ERROR = 500;
}